// extracted by mini-css-extract-plugin
module.exports = {"col":"styles_col__226Hk"};